/* global grecaptcha */
import Blue from '~/core'

new Blue({
  name: 'Floating Tab Number Verification',
  selector: '.floating-tab__modal.floating-tab--number',
  setup(container) {
    const uniqueId = container.getAttribute('data-unique-id')

    const formWrapper = container.querySelector('.blue-form')
    const form = container.querySelector('form')

    const PhoneField = `#N_USPhone_Value_${uniqueId}`
    const PhoneFieldError = `#phone_value_error_${uniqueId}`
    // const RecaptchaField = `#recaptcha_${uniqueId}`
    const RecaptchaFieldError = `#recaptcha_error_${uniqueId}`

    form.addEventListener('submit', async function (event) {
      event.preventDefault()

      const phoneInput = form.querySelector(PhoneField)
      const phoneError = form.querySelector(PhoneFieldError)
      const recaptchaError = form.querySelector(RecaptchaFieldError)
      const endpoint = form.getAttribute('action')

      // Clear previous error messages
      phoneError.style.display = 'none'
      recaptchaError.style.display = 'none'

      const phoneRegex = /^\+?[1-9]\d{1,14}$/
      const phoneValue = phoneInput.value.replace(/\D/g, '')

      if (!phoneRegex.test(phoneValue)) {
        phoneError.style.display = 'block'
        return
      }

      // Validate reCAPTCHA
      const recaptchaResponse = grecaptcha.getResponse()
      if (!recaptchaResponse) {
        recaptchaError.style.display = 'block'
        return
      }

      // Retrieve the AntiForgeryToken value from the hidden input field
      var tokenVal = document.querySelector('input[name="__RequestVerificationToken"]').value
      // Prepare data to send
      const data = {
        PhoneNumber: phoneValue,
      }

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            RequestVerificationToken: tokenVal,
          },
          body: JSON.stringify(data),
          credentials: 'include', // attach cookies
        })

        // Handle the response
        const result = await response.json()
        // Test code only
        // const result = {
        //   message:
        //     '<p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Pariatur quasi totam architecto repellat assumenda non? Sunt quibusdam ullam iure commodi.</p><p>Quos tempora nemo debitis eligendi possimus, <a href="#">velit itaque nulla</a>, cupiditate corporis labore pariatur sequi ipsa id nisi.</p>',
        // }

        // Show the correct breached or not breached message
        if (result.message == 'was') {
          let breached = formWrapper.querySelector('.blue-form__response_breached')
          breached.style.display = 'block'
        } else {
          let nonBreached = formWrapper.querySelector('.blue-form__response_nonbreached')
          nonBreached.style.display = 'block'
        }

        formWrapper.classList.add('show-response')
      } catch (error) {
        console.error('Error submitting the form:', error)
        alert('An error occurred. Please try again later.')
      }
    })
  },
})
